import {Service} from "@/services/Service";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";

export class CacheService extends Service {

    private cache = new Map<string, any>();

    protected constructor() {
        super();
    }

    public get(key: CacheKeyEnum|string, customerCode: string|null = null): any {
        const item: CachedItem | null = this.cache.get((customerCode ?? this.getCustomerCode()) + '.' + key);
        if (!item) {
            return null;
        }

        if (item.expirationTime === -1 || item.expirationTime > Date.now()) {
            return item.value;
        }

        this.invalidate(key, customerCode);
        return null;
    }

    public set(
        key: CacheKeyEnum|string,
        value: any,
        customerCode: string|null = null,
        expiration: number = -1
    ): any {
        const expirationTime = (expiration > -1)
            ? Date.now() + expiration
            : expiration;
        this.cache.set(
            (customerCode ?? this.getCustomerCode()) + '.' + key,
            {
                value: value,
                expirationTine: expirationTime
            }
        );
    }

    public invalidate(key: CacheKeyEnum|string, customerCode: string|null = null): void {
        this.cache.delete((customerCode ?? this.getCustomerCode()) + '.' + key);
    }

    public invalidateByPrefix(prefix: string, customerCode: string|null = null): void {
        const fullPrefix = (customerCode ?? this.getCustomerCode()) + '.' + prefix;
        Array.from(this.cache.keys())
            .filter(key => key.startsWith(fullPrefix))
            .forEach(key => this.cache.delete(key));
    }
}

interface CachedItem {
    value: any,
    expirationTime: number
}
